import React from 'react';
import { useParams } from 'react-router';
import { useTiersCtx } from '@europrocurement/l2d-modules/providers/TiersProvider';
import { FlexyTabs, TabStructure } from '@europrocurement/flexy-components';
import { getSanitizedId } from '../../../../utils/sanitize';
import { PrescriberResume } from '../PrescriberResume';

const PrescriberDetailBody: React.FunctionComponent = function () {
    const { id } = useParams();
    const { getTiersById, isFetch } = useTiersCtx();
    const numericId = getSanitizedId(id);
    const loading = !isFetch(Number(numericId));

    if (!numericId || loading) {
        return null;
    }

    const prescripteur = getTiersById(Number(numericId));

    if (!prescripteur) {
        return null;
    }

    const tabs: Array<TabStructure> = [
        {
            tabName: 'resume',
            tabTitle: 'Synthèse',
            tabPanel: <PrescriberResume prescriber={prescripteur} />,
        },
    ];

    return (
        <FlexyTabs
            routerParameterName="crm-prescriber-detail"
            sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '15px' }}
            tabs={tabs}
            scrollbar={false}
            indicatorColor="primary"
            stickyTabs
            tabsSx={{ borderRadius: '12px' }}
        />
    );
};

export default PrescriberDetailBody;
